import { CRY_TYPE } from '@/common/constants/ConstCode';
import ServiceExec from '@/common/utils/ServiceExec';
import store from '@/store';
import { asFormData } from '@/common/utils/module/FormDataSupport';
import { cloneDeep } from 'lodash';

const prefix = '/api/user/gallery';

export default {
  async getHasItem({ commit, getters, state }, payload) {
    const user = store.getters['user/getUserData'];
    if (!user || !user.userNo) {
      return false;
    }
    try {
      const response = await ServiceExec.get(prefix + `/items/${user?.userNo}`);
      commit('setHasItem', response?.data?.length > 0);
      commit('setGalleryItemList', response?.data || []);
    } catch (error) {
      console.error('Error fetching gallery items:', error);
    }
  },

  async getBackgroundList({ commit, getters, state }, { memorialType }) {
    const user = store.getters['user/getUserData'];
    if (!user || !user.userNo) {
      return [];
    }

    try {
      const response = await ServiceExec.get(prefix + `/list/${user?.userNo}/${memorialType}`);

      if (response?.status !== ServiceExec.status.OK) {
        console.warn('No background list found for user:', user.userNo);
        return;
      }

      commit('setList', response?.data || []);
    } catch (error) {
      console.error('Error fetching background list:', error);
      return [];
    }
  },

  async saveGallery({ commit, getters, state }, payload) {
    const param = cloneDeep(payload);
    try {
      const response = await ServiceExec.multiPost(prefix + `/save`, asFormData(param));
      return response?.status === ServiceExec.status.OK;
    } catch (error) {
      console.error('Error saving gallery:', error);
      return false;
    }
  }
};
